import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M26.667 14.5a1 1 0 0 0 .718-1.696l-5.334-5.5a1 1 0 0 0-1.435 0l-5.334 5.5A1 1 0 0 0 16 14.5h4.333V24a1 1 0 1 0 2 0v-9.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 17.5a1 1 0 0 1 .718 1.696l-5.334 5.5a1 1 0 0 1-1.436 0l-5.333-5.5a1 1 0 0 1 .718-1.696h4.333V8a1 1 0 0 1 2 0v9.5z",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }